import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/workflows/{workflowId}/user-workflows']['POST'];
type Input = ThisApi['params'] & ThisApi['body'];
type Output = ThisApi['response'];

const initiateWorkflowAsCreator = async ({
  associatedUserWorkflowId,
  workflowId,
  customerId,
  contexts,
  invoices,
  owners,
  personAttorneyId,
}: Input): Promise<Output> => {
  const response = await noodleApiClient.post(`/workflows/${workflowId}/user-workflows`, {
    associatedUserWorkflowId,
    contexts,
    customerId,
    invoices,
    owners,
    personAttorneyId,
  });
  return response.data;
};

export default initiateWorkflowAsCreator;
